const deBE= {
    login: {
      title: 'Anmelden',
      sign_in_btn: 'Anmelden'
    },
    bar: {
        logout: 'Abmelden',
        languages: 'Sprachen',
        settings: 'Einstellungen öffnen'
    },
    language: {
      name: 'Deutsch (Belgien)',
    },
    attributePage: {
        title: 'Änderungen der Eigenschaften',
        viewChanges: 'Änderungen anzeigen',
        dateTime: 'Datum',
        notificationType: 'Art der Benachrichtigung',
        notificationValue: 'Benachrichtigungswert',
        oldValue: 'Alter Wert',
        newValue: 'Neuer Wert',
        accept: 'Akzeptieren',
        reject: 'Ablehnen',
    },
    Home: 'Startseite',
    load: 'Durchführen der ersten Ladung...',
    Requested: "Angefordert",
    Viewed: "Angesehen",
    Executing: "Wird ausgeführt",
    Completed: "Abgeschlossen",
    Expired: "Abgelaufen",
    Cancelled: "Abgebrochen",
    Error: "Fehler",
    Rejected: "Abgelehnt",
    error: 'Etwas ist schief gelaufen; bitte versuchen Sie es später erneut.',
    displayname: 'Anzeigename',
    givenname: 'Name',
    surname: 'Nachname',
    email: 'E-Mail',
    mail: 'E-Mail',
    name: 'Name',
    firstname: 'Name',
    lastname: 'Nachname',
    footer_copyright: 'Alle Rechte vorbehalten.'
  };
  
  export default deBE;
  